import posthog from 'posthog-js'
import pub from './../public'

// 初始化 PostHog
posthog.init(pub.config.posthogId, {
  // 必选：PostHog 服务地址（默认官方地址，自建实例需修改）
  // api_host: 'https://app.posthog.com',

  // 可选配置
  // autocapture: true, // 自动捕获点击、页面浏览等事件（默认 true）
  // capture_pageview: true, // 自动捕获页面浏览事件（默认 true）
  // persistence: 'localStorage', // 存储用户标识的方式（localStorage/sessionStorage/cookie）
  // disable_session_recording: false, // 是否禁用会话录制（默认 false，即启用）

  api_host: 'https://f.house730.com',
  ui_host: 'https://us.posthog.com',
  defaults: '2025-05-24',
  person_profiles: 'always', // or 'always' to create profiles for anonymous users as well
  feature_flag_refresh_interval: 86400000, // 核心：设置缓存刷新间隔为24小时（86400000毫秒）
  // 确保缓存持久化到LocalStorage
  persistence: 'localStorage',
  // 高级：过滤不需要捕获的元素（如密码框）
  // property_blacklist: ['password', 'credit_card'],

  // 初始化完成后的回调
  loaded: (posthogInstance) => {
    // console.log('PostHog 初始化完成')
    window.posthog = posthogInstance
    // 可选：设置全局用户属性（如设备信息）
    // posthogInstance.setPersonProperties({
    //   device: navigator.userAgent,
    //   browser: navigator.vendor
    // });
  },
})

const POSTHOG_TIMEOUT_MS = 5000 // onFeatureFlags 超时时间（毫秒）

function buildPayloadsFromCache () {
  let flagPayloads = []
  let flagPayloadsData = []
  try {
    let enabledList =
      JSON.parse(localStorage.getItem(`ph_${pub.config.posthogId}_posthog`)) || []
    let payloadList = enabledList.$feature_flag_payloads || []
    Object.keys(payloadList).forEach((item) => {
      try {
        const parsed = JSON.parse(payloadList[item])
        if (parsed && typeof parsed === 'object') {
          flagPayloads.push(parsed)
        }
      } catch (e) {
        console.warn('[PostHog] 跳过无效 payload:', item, e)
      }
    })
    flagPayloadsData = flagPayloads && flagPayloads.length ? flagPayloads.map((flagPayload) => {
      return {
        jira: `jr${flagPayload.jira}`,
        version: flagPayload.version,
      }
    }) : []
  } catch (e) {
    console.warn('[PostHog] 解析 localStorage 缓存失败:', e)
  }
  return flagPayloadsData
}

export function posthogPayloadsMethod (_flagNames) {
  return new Promise((resolve) => {
    let settled = false
    const settle = (data, source) => {
      if (settled) { return }
      settled = true
      clearTimeout(timer)
      console.log(`[PostHog] payloads 来源: ${source}`, data)
      resolve(data)
    }

    // 超时保底：防止 onFeatureFlags 永远不触发（如 SDK 被广告拦截器完全屏蔽）
    const timer = setTimeout(() => {
      const cached = buildPayloadsFromCache()
      console.warn('[PostHog] onFeatureFlags 超时，降级使用 localStorage 缓存')
      settle(cached, 'timeout-cache')
    }, POSTHOG_TIMEOUT_MS)

    // 等待 feature flags 加载完成
    posthog.onFeatureFlags((_flags, _variants, meta) => {
      if (meta && meta.errorsLoading) {
        console.warn('[PostHog] feature flags 加载失败（可能被防火墙/广告拦截器阻断）')
      }
      const data = buildPayloadsFromCache()
      settle(data, meta && meta.errorsLoading ? 'cache-with-errors' : 'flags-loaded')
    })
  })
}

function setupFeatureFlagListener (callBack) {
  posthog.onFeatureFlags((flags, _variants, meta) => {
    if (meta && meta.errorsLoading) {
      console.warn('[PostHog] feature flags 加载失败（可能被防火墙/广告拦截器阻断）')
    }
    const success = !(meta && meta.errorsLoading) || flags.length > 0;
    callBack(success);
  });
}


export function getFeatureFlagVariant (flagName) {
  return new Promise((resolve) => {
    const variant = posthog.getFeatureFlag(flagName, { send_event: false });
    if (variant !== null && variant !== undefined) {
      resolve(String(variant));
      return;
    }
    setupFeatureFlagListener((success) => {
      if (success) {
        const featureFlag = posthog.getFeatureFlag(flagName);
        resolve(featureFlag !== null && featureFlag !== undefined ? String(featureFlag) : 'control');
      } else {
        resolve('control');
      }
    });
  });
}


// 导出实例供全局使用
export default posthog
